export const WorkspaceUserActionTypes = {
  CREATE_WORKSPACE_USERS: '@@workspaceUser/CREATE_WORKSPACE_USER',
  CREATE_WORKSPACE_USERS_SUCCESS: '@@workspaceUser/CREATE_WORKSPACE_USERS_SUCCESS',
  CREATE_WORKSPACE_USERS_FAILURE: '@@workspaceUser/CREATE_WORKSPACE_USERS_FAILURE',
  DELETE_WORKSPACE_USER: '@@workspaceUser/DELETE_WORKSPACE_USER',
  DELETE_WORKSPACE_USER_SUCCESS: '@@workspaceUser/DELETE_WORKSPACE_USER_SUCCESS',
  DELETE_WORKSPACE_USER_FAILURE: '@@workspaceUser/DELETE_WORKSPACE_USER_FAILURE',
}

export interface IWorkspaceUser {
  readonly id: number
  readonly attributes: IWorkspaceUserAttributes
}

export interface IWorkspaceUserAttributes {
  readonly accessType: string
  readonly accountUserId: number
  readonly workspaceId: number
  readonly workspaceName: string
}

export interface IWorkspaceUserData {
  readonly id: string
  readonly type: 'workspaceUser'
  readonly attributes: IWorkspaceUserAttributes
}

export interface ICreateWorkspaceUsersPayload {
  readonly workspaceIds: number[]
  readonly accountUserIds: number[]
}

export interface IDeleteWorkspaceUserPayload {
  readonly workspaceUserId: number
}

export type IDeleteWorkspaceUserSuccessPayload = IDeleteWorkspaceUserPayload
